__turbopack_context__.v({
  "clearButton": "ActiveFilters-module-scss-module__3o6SkW__clearButton",
  "fade-in": "ActiveFilters-module-scss-module__3o6SkW__fade-in",
  "filterGroup": "ActiveFilters-module-scss-module__3o6SkW__filterGroup",
  "filterGroupRemoveButton": "ActiveFilters-module-scss-module__3o6SkW__filterGroupRemoveButton",
  "item": "ActiveFilters-module-scss-module__3o6SkW__item",
  "itemClearButton": "ActiveFilters-module-scss-module__3o6SkW__itemClearButton",
  "list": "ActiveFilters-module-scss-module__3o6SkW__list",
  "no-transform": "ActiveFilters-module-scss-module__3o6SkW__no-transform",
  "rotate": "ActiveFilters-module-scss-module__3o6SkW__rotate",
  "wrapper": "ActiveFilters-module-scss-module__3o6SkW__wrapper",
});
